import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstOfr: [],
        ofr: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getOfr(state) {
            let ofr = { ...state.ofr }
            return ofr
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        }
    },
    mutations: {
        set(state, ofr) {
			state.ofr = ofr
            if (ofr)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.ofr = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOfr = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOfr(state, ofr) {
            state.ofr = ofr
        },
        setLstOfr(state, lstOfr) {
            state.lstOfr = lstOfr
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, ofrtriagem) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/Labeling/Find/${ofrtriagem}`)
                .then(response => {
                    let ofr = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofr)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, ofrordem) {
            return await this._vm.$axios.get(`/Oryxplace/Labeling/Find/${ofrordem}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/Labeling/Insert", getters.getOfr)
                .then(response => {
                    let ofr = Utils.ValidateAxiosResponse(response.data);
                    commit('setLastUpdatedRegister', ofr);
                    commit("set", ofr)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Oryxplace/Labeling/Update", getters.getOfr)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/Labeling/Delete/${getters.getOfr.ofrordem}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    window.location.reload(true)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findByOrder({ commit, dispatch }, ofrordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/Labeling/FindByOrder/${ofrordem}`)
                .then(response => {
                    let ofr = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofr)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
    }
}